<template>
  <div class="container">
    <div v-if="!isCompare" class="no-compare">
      <div class="top">
        <span class="title">{{ selectedTurbine.turbineType }}</span>
        <!-- 头部参数选择 -->
        <el-form :inline="true" :model="formInline" class="form">
          <el-form-item class="turbulent-select" label="湍流">
            <div class="power-curve-item" style="text-align: left">
              <el-select
                v-show="!turbulentMultipleSelect"
                v-model="turbulentValue"
                :placeholder="turbulentValue.length > 0 ? '' : '请选择湍流'"
                size="mini"
                multiple
                :multiple-limit="8"
                filterable
                allow-create
                default-first-option
                v-defaultSelect="[
                  turbulentValue,
                  turbulentOptions,
                  'value',
                  'disabled',
                  true
                ]"
              >
                <el-option
                  v-for="item in turbulentOptions"
                  :key="item.value"
                  :disabled="item.disabled"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-show="turbulentMultipleSelect"
                v-model="singleTurbulentValue"
                :placeholder="turbulentValue.length > 0 ? '' : '请选择湍流'"
                size="mini"
                filterable
                default-first-option
                @change="changeTurbulentValue"
              >
                <el-option
                  v-for="item in turbulentOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <!-- <span class="percentage">%</span> -->
            </div>
          </el-form-item>
          <el-form-item class="wspd-select" label="空气密度">
            <div class="power-curve-item" style="text-align: left">
              <el-select
                v-show="!wspdMultipleSelect"
                :disabled="wspdMultipleSelect"
                v-model="wspdValue"
                :placeholder="wspdValue.length > 0 ? '' : '请选择空气密度'"
                size="mini"
                multiple
                :multiple-limit="8"
                filterable
                allow-create
                default-first-option
                @change="changeWspdValue"
                v-defaultSelect="[
                  wspdValue,
                  wspdOptions,
                  'value',
                  'disabled',
                  true
                ]"
              >
                <el-option
                  v-for="item in wspdOptions"
                  :disabled="item.disabled"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-show="wspdMultipleSelect"
                v-model="singleWspdValue"
                :placeholder="wspdValue.length > 0 ? '' : '请选择空气密度'"
                size="mini"
                filterable
                default-first-option
                @change="changeSingleWspdValue"
              >
                <el-option
                  v-for="item in wspdOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <span class="percentage">kg/m³</span>
            </div>
          </el-form-item>
          <!-- 图表类型 -->
          <el-form-item
            class="subtype-select"
            label="图表"
            v-if="wspdValue.length > 1 || turbulentValue.length > 1"
          >
            <div class="power-curve-item">
              <el-select v-model="subtypeValue" placeholder="请选择图表类型">
                <el-option
                  v-for="item in subtypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!--<el-form-item class="search_btn">
            <ct-button type="primary" :btnClick="onSubmit">确认</ct-button>
          </el-form-item>-->
        </el-form>
      </div>

      <!-- 曲线内容展示区 -->
      <div class="content-wrapper">
        <!--无曲线数据-->
        <div class="empty" v-if="showEmpty">
          <span>暂无数据</span>
        </div>
        <!--曲线内容-->
        <div v-else>
          <!-- 功率-推力系数 -->
          <div
            class="power-curve-content"
            v-if="wspdValue.length === 1 && turbulentValue.length === 1"
          >
            <div
              v-loading="tableLoading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(254, 254, 255, 0.8)"
              class="res-chart"
            >
              <echart
                :option="powercurveOptions"
                :notMerge="true"
                :divStyle="{ height: '400px', width: '99%' }"
              ></echart>
            </div>
            <el-table
              :data="powerCurveTableData"
              v-loading="tableLoading"
              border
              max-height="400px"
              size="mini"
              key="11"
              style="margin: 40px auto 0;width: 100%;"
              :header-cell-style="headerCellStyle"
              :cell-style="{ 'text-align': 'center' }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                label="风速（m/s）"
                prop="wspd"
              ></el-table-column>
              <el-table-column
                label="功率（kW）"
                prop="power"
              ></el-table-column>
              <el-table-column label="推力系数" prop="thrust"></el-table-column>
            </el-table>
          </div>

          <!-- 多条功率曲线 -->
          <div v-else class="power-curve-content" :style="powerCurveStyle">
            <div
              v-loading="tableLoading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(254, 254, 255, 0.8)"
              class="res-chart"
            >
              <div>
                <echart
                  :option="powercurvesOptions"
                  :notMerge="true"
                  :divStyle="{ height: '400px', width: '99%' }"
                ></echart>
              </div>
            </div>
            <el-table
              :data="powerCurveMoreTableData"
              border
              max-height="400px"
              size="mini"
              key="22"
              v-loading="tableLoading"
              style="margin: 40px auto 0;width: 100%;"
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
              :row-class-name="tableRowClassName"
            >
              <template>
                <el-table-column
                  label="风速(m/s)"
                  prop="wspd"
                ></el-table-column>
                <el-table-column
                  v-for="(item, index) in columnsHeader"
                  :label="item.label"
                  :key="index"
                  :prop="item.prop"
                ></el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!--功率曲线对比-->
    <div v-else class="compare">
      <div class="top">
        <div class="compare-top">
          <div
            v-for="(item, index) in selectList"
            :key="index"
            class="header-select"
          >
            <div>
              <span>机型：{{ item.label }}</span>
            </div>
            <div v-if="comparePowerCurveType == 3">
              <span>湍流：</span>
              <el-select
                v-model="editData['powervalue' + item.id]"
                placeholder="请选择湍流"
                size="mini"
              >
                <el-option
                  v-for="item in compareTurbulentOptions[item.id]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div
              v-if="comparePowerCurveType == 3 || comparePowerCurveType == 4"
            >
              <span>空气密度（kg/m&sup3;）：</span>
              <el-select
                v-model="editData['wspdvalue' + item.id]"
                placeholder="请选择空气密度"
                size="mini"
              >
                <el-option
                  v-for="item in compareWspdOptions[item.id]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div>
              <el-button
                v-if="index === selectList.length - 1"
                size="mini"
                type="primary"
                @click="confirmClick"
                >确认</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <!-- 功率对比曲线内容展示 -->
      <div class="power-curve-compare">
        <!--无对比曲线数据-->
        <div v-if="showCompareEmpty" class="empty">
          <span>暂无数据</span>
        </div>
        <!-- 曲线内容 -->
        <div v-else>
          <div
            v-loading="tableLoading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(254, 254, 255, 0.8)"
            class="res-chart"
          >
            <echart
              :option="powercurvecompareOptions"
              :notMerge="true"
              :divStyle="{ height: '400px', width: '99%' }"
            ></echart>
          </div>
          <el-table
            :data="powerCurveCompareTableData"
            v-loading="tableCompareLoading"
            border
            size="mini"
            max-height="400px"
            style="margin: 40px auto 0;width: 100%;"
            :row-class-name="tableRowClassName"
            key="33"
          >
            <el-table-column label="风速（m/s）" prop="wspd"></el-table-column>
            <el-table-column
              v-for="(item, index) in columns"
              :label="item.label"
              :prop="item.prop"
              :key="index"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  getPowerTurbulentCurve,
  getMorePowerCurve,
  getComparePowerCurve
} from '../helper/curveOptions.js';
import {
  filterPowerCurveData,
  filterPowerCurveMoreData,
  filterCurveMoreTableData
} from '../helper/utils.js';
import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    comparePowerCurveType: Number
  },
  components: {},
  data() {
    return {
      showEmpty: false, // 数据是否为空
      selectedTurbine: {}, // 当前点击展示的机型
      formInline: {},
      turbulentValue: [], // 湍流选择多选
      turbulentMultipleSelect: false, // 是否展示湍流的多选模式
      turbulentOptions: [], // 获取的湍流列表
      singleTurbulentValue: '', // 选择单个湍流
      wspdValue: [], // 空气密度多选
      wspdMultipleSelect: false, // 是否展示空气密度多选模式
      wspdOptions: [], // 获取的空气密度列表
      singleWspdValue: '', // 单个的空气密度
      tableLoading: false,
      // powercurveOptions: {}, // 功率推力曲线的echarts配置
      // powerCurveTableData: [], // 功率推力表格数据
      // 东气项目变量
      topTitle: '',
      powerCurveStyle: '0',
      // 功率曲线页面
      powerCurveTableData: [],
      powerCurvedata: {},
      // 多对1
      // 多条功率曲线
      powerCurveMoreTableData: [],
      powerCurvedataMore: {},
      // 多条功率曲线原始值
      powerCurveMore: [],
      // 选择的机型id
      idList: [],
      // 对比功率曲线湍流选择
      turbulentValueCompare: 0.1,
      // 对比功率曲线空气密度选择
      wspdValueCompare: 1.225,
      // 动态select绑定的数据
      editData: {},
      // 对比曲线数据
      powerCurvedataCompare: {},
      // 对比功率表格数据
      powerCurveCompareTableData: [],
      // 对比表格的loading
      tableCompareLoading: false,
      showCompareEmpty: false,
      // 选择的机型的数据
      paddingValue: {
        paddingTop: '70px'
      },
      // 功率曲线对比的集合
      compareWspdOptions: {},
      compareTurbulentOptions: {},
      // echart图表配置变量
      powercurveOptions: null,
      powercurvescpOptions: {},
      powercurvesOptions: null,
      // 对比曲线的配置
      powercurvecompareOptions: null,
      // 刷新页面重复发起请求问题
      // 单选多选页面请求问题
      isChangeWspdValue: false,
      isChangeTurbulentValue: false,
      // 对比功率曲线的初始值问题
      compareWspdFirst: [],
      compareTurbulentFirst: [],
      // 表格头部样式
      headerCellStyle: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#444455',
        backgroundColor: 'rgb(180, 211, 238)',
        textAlign: 'center'
      },
      // 图表类型
      subtypeValue: '1',
      subtypeOptions: [
        {
          value: '1',
          label: '功率（KW）'
        },
        {
          value: '2',
          label: '推力系数'
        }
      ],
      // 对比功率曲线返回的元数据
      compareTableData: []
      // 对比的时候切换功率曲线
      // compareSelectType: '功率曲线'
    };
  },
  computed: {
    ...mapState('model', ['isCompare', 'turbineCheckedList', 'currentTurbine']),
    selectList() {
      if (isEmpty(this.turbineCheckedList)) return [];
      const selects = [];
      this.turbineCheckedList.forEach((item, i) => {
        selects.push({
          label: item.turbineType,
          value: `powervalue${i === 0 ? '' : i}`,
          wspdValue: `wspdvalue${i === 0 ? '' : i}`,
          id: item.turbineTypeId
        });
      });
      return selects;
    },
    // 多条功率曲线的table-header
    columnsHeader() {
      if (isEmpty(this.powerCurveMore)) return [];
      const cols = [];
      this.powerCurveMore.forEach((eco, i) => {
        let str;
        if (this.turbulentValue.length > 1) {
          let turbulenceStr = `功率（TI=${eco[0].turbulence}）`;
          str = turbulenceStr;
          if (this.subtypeValue == '2') {
            str = `推力系数${i === 0 ? '' : i}`;
          }
        }
        if (this.wspdValue.length > 1) {
          str = `空气密度${eco[0].density}功率`;
          if (this.subtypeValue == '2') {
            str = `空气密度${eco[0].density}推力系数`;
          }
        }
        cols.push({
          label: str,
          prop: `power${i === 0 ? '' : i}`
        });
      });
      return cols;
    },
    // 对比功率曲线的列数据
    columns() {
      if (isEmpty(this.compareTableData)) return [];
      const cols = [];
      this.compareTableData.forEach((eco, i) => {
        cols.push({
          label: eco[0].turbineType,
          prop: `power${i === 0 ? '' : i}`
        });
      });
      return cols;
    }
  },
  watch: {
    // 对比图表切换
    comparePowerCurveType() {
      this.fetchComparePowerCurveList();
    },
    // 对比的多个选择select
    editData: {
      handler(val) {
        console.log(val);
      },
      deep: true
    },
    // 当前点击的的机型对象==>变换
    currentTurbine(val) {
      this.$nextTick(() => {
        this.showEmpty = false;
      });
      this.wspdValue = [];
      this.turbulentValue = [];
      if (typeof val === 'object' && Object.keys(val).length <= 0) {
        this.showEmpty = true;
        return;
      }
      this.selectedTurbine = val;
      this.idList = [val.turbineTypeId];
      if (!this.isCompare) {
        if (this.wspdValue.length > 1 || this.turbulentValue.length > 1) {
          this.fetchPowerCurveMore();
        } else {
          this.wspdValue = [];
          this.turbulentValue = [];
          this.fetch();
        }
      }
    },
    turbineCheckedList(newVal, oldVal) {
      if (newVal.length <= 1) {
        return;
      }
      let newval = newVal.map(item => {
        return item.turbineTypeId;
      });
      let oldval = oldVal.map(item => {
        return item.turbineTypeId;
      });
      this.paddingValue.paddingTop = `${newval.length * 50}px`;
      this.idList = newVal;
      if (this.isCompare) {
        if (oldval.length > newval.length) {
          oldval.forEach(item => {
            if (!newval.includes(item)) {
              //console.log('yuzhi', item);
              delete this.editData['wspdvalue' + item];
              delete this.editData['powervalue' + item];
              this.compareWspdFirst.pop();
            }
          });
        } else {
          newval.forEach(item => {
            if (!oldval.includes(item)) {
              this.fetchTurbulenceList(item);
            }
          });
        }
      }
    },
    // 监听湍流的值的变化
    turbulentValue(val) {
      // 把空气密度已经修改的值赋值为false，就不会多发请求
      this.isChangeWspdValue = false;
      if (val.length < 1) {
        this.showEmpty = true;
        return;
      }
      this.wspdMultipleSelect = val.length > 1 ? true : false;
      // 湍流长度大于1，空气密度多选框为空时，改变湍流应该发生请求
      if (val.length > 1 && this.singleWspdValue) {
        this.fetchPowerCurveMore();
      }
      // if (val.length > 1 && this.wspdValue.length > 0) {
      //   this.singleWspdValue = this.wspdValue[0];
      //   this.fetchPowerCurveMore();
      // }
      if (val.length > 4) {
        this.powerCurveStyle = {
          paddingTop: '0'
        };
      }
      this.powerCurveMore = [];
      if (val.length === 1 && this.wspdValue.length > 0) {
        this.wspdOptions = null;
        this.fetchDensityList();
        this.powerCurveStyle = {
          paddingTop: '0'
        };
      }
    },
    // 监听空气密度值的变化
    wspdValue(val) {
      if (val.length < 1) {
        this.showEmpty = true;
        return;
      }
      this.turbulentMultipleSelect = val.length > 1 ? true : false;
      if (val.length > 1 && this.turbulentValue.length > 0) {
        this.singleTurbulentValue = this.turbulentValue[0];
        this.fetchPowerCurveMore();
      }
      if (val.length > 4) {
        this.powerCurveStyle = {
          paddingTop: '0'
        };
      }
      this.powerCurveMore = [];
      if (val.length === 1 && this.turbulentValue.length > 0) {
        this.powerCurveStyle = {
          paddingTop: '0'
        };
        if (this.isChangeWspdValue) {
          this.fetchPowerCurve();
        }
      }
      // 湍流为空时湍流单选框值也为空
      if (val.length > 1 && this.turbulentValue.length === 0) {
        this.singleTurbulentValue = '';
      }
    },
    isCompare(val) {
      if (!val) {
        // test
        // this.compareWspdFirst = [];
        // this.compareTurbulentFirst = [];
        this.editData = {};
        this.compareWspdOptions = {};
        this.compareTurbulentOptions = {};
        // TODO TEST取消全选
        this.selectedTurbine = this.currentTurbine;
        this.wspdValue = [];
        this.turbulentValue = [];
        this.fetch();
      } else {
        this.compareWspdFirst = [];
        this.compareTurbulentFirst = [];
        this.turbineCheckedList.forEach(item => {
          this.fetchTurbulenceList(item.turbineTypeId);
        });
      }
    },
    compareWspdFirst(val) {
      // TODO 对比这里的问题
      if (val.length === this.turbineCheckedList.length) {
        this.$nextTick(() => {
          this.fetchComparePowerCurveList();
        });
      }
    },
    // 图表类型变化
    subtypeValue() {
      if (this.turbulentValue.length > 0 && this.wspdValue.length > 0) {
        this.fetchPowerCurveMore();
      }
      // 湍流长度大于1时，空气密度多选为空，单选有值需要发起请求
      // if (this.turbulentValue.length > 1 && this.singleWspdValue) {
      //   this.fetchPowerCurveMore();
      // }
    }
  },
  mounted() {
    if (Object.keys(this.currentTurbine).length > 0) {
      this.selectedTurbine = this.currentTurbine;
      if (this.isCompare) {
        this.turbineCheckedList.forEach(item => {
          this.fetchTurbulenceList(item.turbineTypeId);
        });
      } else {
        this.fetch();
        // this.selectedTurbine = this.currentTurbine;
        // this.wspdValue = [];
        // this.turbulentValue = [];
        // this.fetch();
      }
    }
  },
  methods: {
    // table表格样式设置
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return 'custom-table-row-odd';
      } else {
        return 'custom-table-row-even';
      }
    },
    // 单选改变湍流
    changeTurbulentValue() {
      this.fetchPowerCurveMore();
    },
    // 多选改变空气密度
    changeWspdValue() {
      this.isChangeWspdValue = true;
    },
    // 单选改变空气密度
    changeSingleWspdValue() {
      this.fetchPowerCurveMore();
    },
    async fetch() {
      if (this.tableLoading) {
        return;
      }
      this.tableLoading = true;
      try {
        await this.fetchTurbulenceList();
        await this.fetchDensityList();
      } catch (e) {
        this.tableLoading = false;
        throw e;
      }
      this.tableLoading = false;
    },
    // 获取功率曲线湍流集合
    async fetchTurbulenceList(id) {
      if (!id && !this.selectedTurbine.turbineTypeId) {
        return;
      }
      let apiKey = 'test';
      let result = await this.$fetch(
        '/windfarm/turbineType/getPowerCurveTurbulenceList',
        {
          params: {
            turbineTypeId: this.isCompare
              ? parseInt(id)
              : parseInt(this.selectedTurbine.turbineTypeId),
            apiKey
          },
          showError: true
        }
      );
      if (!result.data.turbulenceList) {
        return;
      }
      let turbulenceListArr = [];
      result.data.turbulenceList.map(item => {
        let turbulenceListObj = {};
        turbulenceListObj.value = item.turbulence;
        turbulenceListObj.label = item.turbulence;
        turbulenceListObj.disabled = false;
        // turbulenceListObj.disabled = false;
        turbulenceListArr.push(turbulenceListObj);
      });
      this.turbulentOptions = turbulenceListArr;
      this.singleTurbulentValue = turbulenceListArr[0].value;
      this.turbulentValue.push(turbulenceListArr[0].value);
      if (this.isCompare) {
        // this.compareTurbulentOptions.push(turbulenceListArr);
        this.compareTurbulentOptions[id] = turbulenceListArr;
        this.compareTurbulentFirst.push(turbulenceListArr[0].value);
        await this.fetchDensityList(id, turbulenceListArr[0].value);
        this.$set(this.editData, 'powervalue' + id, turbulenceListArr[0].value);
      }
    },
    // 获取功率曲线空气密度集合
    async fetchDensityList(id, val) {
      this.wspdValue = [];
      this.singleWspdValue = '';
      let turbulence;
      if (this.isCompare) {
        this.turbineCheckedList.forEach(item => {
          if (item.turbineTypeId === id) {
            turbulence = val;
          }
        });
      } else {
        if (this.turbulentValue.length === 1) {
          turbulence = this.turbulentValue[0];
        } else {
          turbulence = '';
        }
      }
      if (!id && !this.selectedTurbine.turbineTypeId) {
        return;
      }
      let apiKey = 'test';
      let result = await this.$fetch(
        '/windfarm/turbineType/getPowerCurveDensityList',
        {
          params: {
            turbineTypeId: this.isCompare
              ? parseInt(id)
              : parseInt(this.selectedTurbine.turbineTypeId),
            turbulence,
            apiKey
          },
          showError: true
        }
      );
      if (!result.data.densityList) {
        return;
      }
      let wspdOptionsArr = [];
      result.data.densityList.map(item => {
        let wspdOptionsObj = {};
        wspdOptionsObj.value = item.density;
        wspdOptionsObj.label = item.density;
        wspdOptionsObj.disabled = false;
        wspdOptionsArr.push(wspdOptionsObj);
      });
      this.wspdOptions = wspdOptionsArr;
      this.singleWspdValue = wspdOptionsArr[0].value;
      this.wspdValue.push(wspdOptionsArr[0].value);
      if (this.isCompare) {
        this.compareWspdOptions[id] = wspdOptionsArr;
        this.compareWspdFirst.push(wspdOptionsArr[0].value);
        this.$set(this.editData, 'wspdvalue' + id, wspdOptionsArr[0].value);
      }
      if (this.turbulentValue.length === 1 && this.wspdValue.length > 0) {
        await this.fetchPowerCurve();
      }
    },
    // 获取功率-推力系数曲线
    async fetchPowerCurve() {
      this.showEmpty = false;
      let apiKey = 'test';
      let result = await this.$fetch('/windfarm/turbineType/getCurveData', {
        params: {
          density: this.wspdValue[0],
          turbulence: this.turbulentValue[0],
          turbineTypeId: parseInt(this.selectedTurbine.turbineTypeId),
          apiKey
        },
        showError: true
      });
      if (!result.data.curveDataList) {
        this.showEmpty = true;
        return;
      }
      // 去除相同风速的同样的数据
      let obj = {};
      let data = result.data.curveDataList.reduce(function(
        prevArr,
        currentItem
      ) {
        obj[currentItem.wspd]
          ? ''
          : (obj[currentItem.wspd] = true && prevArr.push(currentItem));
        return prevArr;
      },
      []);
      this.powerCurveTableData = data;
      this.powerCurvedata = filterPowerCurveData(data);
      this.$nextTick(() => {
        this.powerCurveInit(this.powerCurvedata);
      });
    },
    powerCurveInit(obj) {
      this.powercurveOptions = getPowerTurbulentCurve(obj);
    },
    // 获取多条功率推力曲线
    async fetchPowerCurveMore() {
      if (this.isCompare) {
        return;
      }
      this.tableLoading = true;
      this.showEmpty = false;
      this.powerCurveMoreTableData = [];
      this.powerCurvedataMore = {};
      let result = await this.$fetch('/windfarm/turbineType/getCurveDataList', {
        params: {
          densitys:
            this.wspdValue.length > 1
              ? this.wspdValue.join(',')
              : this.singleWspdValue,
          turbulences:
            this.turbulentValue.length > 1
              ? this.turbulentValue.join(',')
              : this.singleTurbulentValue,
          turbineTypeId: this.selectedTurbine.turbineTypeId,
          type: this.subtypeValue
        },
        showError: true
      });
      if (!result.data.curveDataList) {
        this.showEmpty = true;
        this.tableLoading = false;
        return;
      }
      /* 多条功率曲线表格 */
      if (this.subtypeValue == '1') {
        this.$nextTick(() => {
          this.powerCurveMoreTableData = filterCurveMoreTableData(
            result.data.curveDataList,
            null,
            this.subtypeValue,
            result.data.wspdList
          );
        });
      } else {
        this.$nextTick(() => {
          this.powerCurveMoreTableData = filterCurveMoreTableData(
            result.data.curveDataList,
            null,
            this.subtypeValue,
            result.data.wspdList
          );
        });
      }
      this.powerCurvedataMore = filterPowerCurveMoreData(
        result.data.curveDataList,
        5,
        this.subtypeValue
      );
      /* 原始data的值 */
      this.powerCurveMore = result.data.curveDataList;
      this.$nextTick(() => {
        this.powerCurveMoreInit(this.powerCurvedataMore);
      });
      this.tableLoading = false;
    },
    powerCurveMoreInit(data) {
      let legends = [];
      this.powerCurveMore.forEach((item, i) => {
        let str;
        if (this.turbulentValue.length > 1) {
          let turbulenceStr = `功率（TI=${item[0].turbulence}）`;
          str = turbulenceStr;
          if (this.subtypeValue == '2') {
            str = `推力系数${i === 0 ? '' : i}`;
          }
        } else if (this.wspdValue.length > 1) {
          str = `空气密度${item[0].density}功率`;
          if (this.subtypeValue == '2') {
            str = `空气密度${item[0].density}推力系数`;
          }
        }
        legends.push(str);
      });
      let serciesData = this.powerCurveMore.map((item, index) => {
        return {
          name: legends[index],
          type: 'line',
          data: data[index]
        };
      });
      this.powercurvesOptions = getMorePowerCurve(
        data,
        legends,
        serciesData,
        this.subtypeValue
      );
    },
    handleSelectData(dataDeep) {
      let densitys = [];
      let turbulences = [];
      // let keys = Object.keys(dataDeep);
      this.turbineCheckedList.forEach(item => {
        let density = dataDeep['wspdvalue' + item.turbineTypeId];
        let turbulence = dataDeep['powervalue' + item.turbineTypeId];
        densitys.push(density);
        turbulences.push(turbulence);
      });
      // keys.forEach(item => {
      //   if (item.substring(0, 9) === 'wspdvalue') {
      //     densitys.push(dataDeep[item]);
      //   }
      //   if (item.substring(0, 10) === 'powervalue') {
      //     turbulences.push(dataDeep[item]);
      //   }
      // });
      // for (let key in dataDeep) {
      //   if (key.substring(0, 9) === 'wspdvalue') {
      //     densitys.push(dataDeep[key]);
      //   }
      //   if (key.substring(0, 10) === 'powervalue') {
      //     turbulences.push(dataDeep[key]);
      //   }
      // }
      return { densitys, turbulences };
    },
    // 获取对比功率曲线
    async fetchComparePowerCurveList(val) {
      let compareSelectType;
      let filterType;
      if (this.comparePowerCurveType == 3) {
        compareSelectType = 1;
        filterType = 3;
      } else {
        compareSelectType = 2;
        filterType = 4;
      }
      //console.log('11111111111111111111');
      //console.log(this.editData);
      let dataDeep = JSON.parse(JSON.stringify(this.editData));
      let dataObj = this.handleSelectData(dataDeep);
      if (!val && val !== 1) {
        if (dataObj['densitys'].length === 0) {
          this.turbineCheckedList.forEach(item => {
            dataObj['densitys'].push(
              this.compareWspdOptions[item.turbineTypeId][0].value
            );
            dataObj['turbulences'].push(
              this.compareTurbulentOptions[item.turbineTypeId][0].value
            );
          });
        }
      }
      this.tableCompareLoading = true;
      this.showCompareEmpty = false;
      let turbineTypeId = this.turbineCheckedList.map(item => {
        return parseInt(item.turbineTypeId);
      });
      let result = await this.$fetch('/windfarm/turbineType/getPowerCurves', {
        params: {
          turbineTypeIds: turbineTypeId.join(','),
          densitys: dataObj.densitys.join(','),
          turbulences: dataObj.turbulences.join(','),
          type: compareSelectType
        },
        showLoading: true,
        showSuccess: true,
        showError: true
      });

      if (!result.data.powerCurveList) {
        this.tableCompareLoading = false;
        this.showCompareEmpty = true;
        return;
      }
      this.powerCurveCompareTableData = [];
      this.$nextTick(() => {
        this.powerCurveCompareTableData = filterCurveMoreTableData(
          result.data.powerCurveList,
          filterType,
          '',
          result.data.wspdList
        );
      });
      // 这里是对比返回的机型列表数据
      this.compareTableData = result.data.powerCurveList;
      this.powerCurvedataCompare = filterPowerCurveMoreData(
        result.data.powerCurveList,
        filterType
      );
      this.$nextTick(() => {
        this.powerCurveCompareInit(this.powerCurvedataCompare, true);
      });
      this.tableCompareLoading = false;
    },
    // 渲染对比曲线
    powerCurveCompareInit(data) {
      let dataLegends = this.compareTableData.map(item => {
        return item[0].turbineType;
      });
      this.powercurvecompareOptions = getComparePowerCurve(
        data,
        dataLegends,
        this.turbineCheckedList,
        this.comparePowerCurveType,
        this.compareTableData
      );
    },
    confirmClick() {
      this.fetchComparePowerCurveList(1);
    }
  },
  directives: {
    defaultSelect: function(el, bindings) {
      //values v-model绑定值
      //options下拉选项
      //prop对应options中的value属性
      //defaultProp默认值判断属性
      //defaultValue默认值判断值

      const [values, options, prop] = bindings.value;
      //需要隐藏的标签索引
      let indexs = [];

      const tempData = values.map(a => options.find(op => op[prop] === a));

      if (tempData.length === 1) {
        indexs.push(0);
      } else {
        indexs = [];
      }

      const dealStyle = function(tags) {
        tags.forEach((el, index) => {
          if (
            indexs.includes(index) &&
            ![...el.classList].includes('select-tag-close-none')
          ) {
            el.classList.add('closeTag');
          } else {
            el.classList.remove('closeTag');
          }
        });
      };
      //设置样式隐藏close icon

      const tags = el.querySelectorAll('.el-tag__close');

      if (tags.length === 0) {
        //初始化tags为空处理

        setTimeout(() => {
          const tagTemp = el.querySelectorAll('.el-tag__close');

          dealStyle(tagTemp);
        });
      } else {
        dealStyle(tags);
      }
    }
  }
};
</script>

<style lang="less" scoped>
/* 选择器只剩一个时隐藏 */
/deep/.closeTag {
  display: none;
}
/* 以下是调整功率曲线头部select */
/deep/.el-select__tags {
  //max-width: 188px !important;
  width: auto !important;
  max-width: none !important;
}
/deep/.el-form-item--mini .el-form-item__content,
.el-form-item--mini .el-form-item__label {
  vertical-align: middle !important;
}
/deep/.el-select {
  //width: 94%;
}
.percentage {
  color: #3c3d45;
}
.container {
  height: 100%;
  width: 100%;
  .no-compare {
    width: 100%;
    height: 100%;
    .top {
      width: 100%;
      background: #d5dde4;
      display: flex;
      align-items: center;
      .title {
        font-size: 18px;
        font-weight: bold;
        color: #444455;
        padding: 8px 20px;
        border-right: 1px solid #32323a;
        margin-right: 25px;
      }
      .el-form-item {
        margin-bottom: 0;
      }
      .form {
        height: 60px;
        display: flex;
        align-items: center;
        flex: 1;
        position: relative;
        .turbulent-select {
          padding-right: 20px;
        }
        .wspd-select {
          padding-right: 20px;
          /* /deep/.el-input__suffix {
            .el-input__icon {
              display: none;
            }
          }
          /deep/.el-input__suffix::before {
            content: 'kg/m³';
          }*/
        }
        .search_btn {
          position: absolute;
          right: 0;
        }
      }
    }
    .content-wrapper {
      width: 100%;
      height: calc(100% - 60px);
      .select-curve {
        width: 96%;
        margin: auto;
        padding: 20px 20px 0 0;
        text-align: right;
      }
      .empty {
        position: absolute;
        top: 50%;
        left: 45%;
        transform: translateX(50%);
        font-size: 14px;
        color: #8f9197;
        height: 100%;
      }
      .power-curve-content {
        width: 96%;
        height: 100%;
        margin: 40px auto 0;
        .res-chart {
          height: 400px;
          padding-bottom: 20px;
          width: 100%;
          margin: 15px auto 20px;
        }
      }
    }
  }
  .compare {
    .power-curve-compare {
      .empty {
        position: absolute;
        top: 50%;
        left: 45%;
        transform: translateX(50%);
        font-size: 14px;
        color: #8f9197;
        height: 100%;
      }
    }
    .top {
      width: 100%;
      display: flex;
      align-items: center;
      .compare-top {
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        width: 100%;
        padding-bottom: 20px;
        // justify-content: center;
        // position: absolute;
        // top: 20px;
        // z-index: 1000;
        //padding-top: 40px;
        // width: calc(100% - 400px);
        overflow: hidden;
        /deep/.el-input__inner {
          //background-color: @bgColor;
          border: none;
          border-bottom: 1px solid #fff;
          border-radius: 0;
          outline: none;
          //color: #fff;
          text-align: center;
          /*max-width: 160px;*/
        }
        /deep/.el-select .el-input .el-input__suffix {
          display: block;
        }
        /deep/.el-select__tags {
          width: auto !important;
          max-width: none !important;
          /deep/.el-tag--info {
            background-color: transparent;
            border: none;
            //color: #fff;
            text-align: center;
          }
        }
        .header-select {
          display: flex;
          align-items: center;
          height: 40px;
          line-height: 40px;
          //background-color: #0477a1;
          margin-top: 5px;
          padding-left: 20px;
          //border: 1px solid black;
          //background-color: @bgColor;
          margin-top: 5px;
          padding-left: 20px;
          //border: 1px solid @bgColor;
          //color: #fff;
          background: #d5dde4;
          div {
            margin-right: 20px;
          }
          div:first-child {
            min-width: 240px;
          }
        }
        .header-select:first-child {
          margin: 0;
        }
      }
    }
  }
}
</style>
